import { removeToken } from './token'
import { getLoginPath } from '../../../utils'
import { removeLocalLoginType } from '../../../core/loginType'
/**
 * 企业微信授权链接
 */
const toWorkWxAuthPathLocalKey = 'workwx_inner_auth_page'
export const setToWorkWxAuthPath = (href) => localStorage.setItem(toWorkWxAuthPathLocalKey, href)
export const getToWorkWxAuthPath = () => localStorage.getItem(toWorkWxAuthPathLocalKey)

/**
 * 企业微信授权链接
 */
const toWorkWxAuthIdsLocalKey = 'workwx_inner_auth_ids'
export const setToWorkWxAuthIds = (ids) => localStorage.setItem(toWorkWxAuthIdsLocalKey, JSON.stringify(ids))
export const getToWorkWxAuthIds = () => JSON.parse(localStorage.getItem(toWorkWxAuthIdsLocalKey) || 'null')
export const removeToWorkWxAuthIds = () => localStorage.removeItem(toWorkWxAuthIdsLocalKey)

/**
 * 跳转去登录
 */
export const toLogin = () => {
  removeLocalLoginType()
  location.href = getLoginPath()
}

/**
 * 跳转去退出登录
 */
export function toSignOut() {
  removeToken()
  toLogin()
}